export const AUTH0_CLIENT_ID = 'CW35eDAgFZ3piZcYLO-uGcJXDU317HRf'
export const AUTH0_DOMAIN = 'createsafe.auth0.com'
export const AUTH0_ID_TOKEN_NAME = 'createsafe-auth'
export const BASE_URL = 'http://localhost:3010'
export const GRAPHQL_URL = ''
export const STRIPE_PUBLISHABLE_KEY = 'pk_test_GhzV8kTV0VFbUsVlxQL47oHq'


console.log('ENV', process.env.NODE_ENV)

export const APP_ROOT = '' // (process.env.NODE_ENV ==='production') ? '/createsafe-web' :''



// WEBPACK FOOTER //
// ./src/consts.js